export const PERMISSIONS = {
  IDENTITY: {
    USERS: {
      READ: 'identity:users:read',
      MANAGE: 'identity:users:manage',
      MANAGE_SYSTEM: 'identity:users:manage-system',
    },
    ROLES: {
      READ: 'identity:roles:read',
      MANAGE: 'identity:roles:manage',
      MANAGE_SYSTEM: 'identity:roles:manage-system',
    },
  },
  CATALOG: {
    PRODUCTS: {
      READ: 'catalog:products:read',
      MANAGE: 'catalog:products:manage',
      UPDATE_PRICE: 'catalog:products:update-price',
    },
  },
  INVENTORY: {
    LOTS: { READ: 'inventory:lots:read' },
    MOVEMENTS: { READ: 'inventory:movements:read' },
    STOCK: { MANAGE: 'inventory:stock:manage' },
  },
  SALES: {
    READ: 'sales:read',
    REGISTER: 'sales:register',
    IMPORT: 'sales:import',
  },
  REPORTING: {
    DASHBOARD: { READ: 'reporting:dashboard:read' },
    STOCK: { READ: 'reporting:stock:read' },
  },
  UI: {
    DASHBOARD: 'ui:dashboard:access',
    CHECKOUT: 'ui:checkout:access',
    SALES_HISTORY: 'ui:sales-history:access',
    PRODUCTS_CATALOG: 'ui:products-catalog:access',
    INVENTORY_LOTS: 'ui:inventory-lots:access',
    REPORTS_STOCK: 'ui:reports-stock:access',
    USERS: 'ui:users:access',
    ROLES_PERMISSIONS: 'ui:roles-permissions:access',
  },
} as const

type LeafValues<T> = T extends string
  ? T
  : T extends Record<string, unknown>
    ? LeafValues<T[keyof T]>
    : never

export type PermissionCode = LeafValues<typeof PERMISSIONS>